__turbopack_context__.v({
  "className": "herr_von_muellerhoff_7f812261-module__O8j2Ea__className",
  "variable": "herr_von_muellerhoff_7f812261-module__O8j2Ea__variable",
});
